import SensorWindowIcon from '@mui/icons-material/SensorWindow';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import SolarPowerIcon from '@mui/icons-material/SolarPower';
import LockIcon from '@mui/icons-material/Lock';
import MedicationIcon from '@mui/icons-material/Medication';
import PestControlIcon from '@mui/icons-material/PestControl';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BathtubIcon from '@mui/icons-material/Bathtub';
import CountertopsIcon from '@mui/icons-material/Countertops';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import BathroomIcon from '@mui/icons-material/Bathroom';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import WaterDamageIcon from '@mui/icons-material/WaterDamage';
import RoofingIcon from '@mui/icons-material/Roofing';
import roofingImage from '../assets/img/roofing.jpg';
import bathroomImage from '../assets/img/bathroom.jpg';
import doorImage from '../assets/img/door.jpg';
import kitchenImage from '../assets/img/kitchen.jpg';
import guttersImage from '../assets/img/gutters.jpg';
import sidingImage from '../assets/img/siding.jpg';
import walkInTubsImage from '../assets/img/walkin-tub.jpg';
import windowImage from '../assets/img/window.jpg';
import hvacImage from '../assets/img/hvac.jpg';
import floorImage from '../assets/img/floor.jpg';


export const activeVerticals = [1, 2, 3, 5, 6, 11, 22, 24];

export const affiliateLinks: { [key: string]: string } = {

  //Leads - affiliateId: url
  '80': 'https://leadgiant.wufoo.com/forms/affiliate-80-cost-per-sale-application/',
  '89': 'https://leadgiant.wufoo.com/forms/affiliate-89-custom-lead-campaigns/',

  // Calls - affiliateId: url
  '79': 'https://leadgiant.wufoo.com/forms/affiliate-79-cost-per-appointment-application/',
  '81': 'https://leadgiant.wufoo.com/forms/affiliate-81-cost-per-transfer-application/',
  '82': 'https://leadgiant.wufoo.com/forms/affiliate-82-branded-call-campaign-application/',
  '112': 'https://leadgiant.wufoo.com/forms/affiliate-112-cost-per-transfer-application/'
};

export const verticalVisualData: { [key: string]: VerticalVisualData }[] = [
  { '1': { icon: <RoofingIcon sx={{ fontSize: 40 }} />, color: '#f44336', image: roofingImage } },
  { '2': { icon: <SensorWindowIcon sx={{ fontSize: 40 }} />, color: '#e91e63', image: windowImage } },
  { '3': { icon: <HouseSidingIcon sx={{ fontSize: 40 }} />, color: '#9c27b0', image: sidingImage } },
  { '4': { icon: <SolarPowerIcon sx={{ fontSize: 40 }} />, color: '#009688', image: '' } },
  { '5': { icon: <BathroomIcon sx={{ fontSize: 40 }} />, color: '#2196f3', image: bathroomImage } },
  { '6': { icon: <BathtubIcon sx={{ fontSize: 40 }} />, color: '#00bcd4', image: walkInTubsImage } },
  { '7': { icon: <LockIcon sx={{ fontSize: 40 }} />, color: '#9c27b0', image: '' } },
  { '8': { icon: <MedicationIcon sx={{ fontSize: 40 }} />, color: '#b2102f', image: '' } },
  { '9': { icon: <PestControlIcon sx={{ fontSize: 40 }} />, color: '#673ab7', image: '' } },
  { '10': { icon: <HealthAndSafetyIcon sx={{ fontSize: 40 }} />, color: '#009688', image: '' } },
  { '11': { icon: <DashboardIcon sx={{ fontSize: 40 }} />, color: '#ffc107', image: floorImage } },
  { '12': { icon: <CountertopsIcon sx={{ fontSize: 40 }} />, color: '#795548', image: kitchenImage } },
  { '13': { icon: <AssignmentTurnedInIcon sx={{ fontSize: 40 }} />, color: '#01579b', image: '' } },
  { '14': { icon: <MeetingRoomIcon sx={{ fontSize: 40 }} />, color: '#01579b', image: doorImage } },
  { '22': { icon: <WaterDamageIcon sx={{ fontSize: 40 }} />, color: '#009688', image: guttersImage } },
  { '24': { icon: <SensorWindowIcon sx={{ fontSize: 40 }} />, color: '#e91e63', image: hvacImage } },
];

export type VerticalOffer = {
  name: string;
  id: string;
};

export const verticalIDToLeadOffers: { [key: string]: VerticalOffer[] }[] = [
  {
    '1': [
      { name: 'Compliant Non 1:1 Consent Roofing Leads', id: '68' },
      // { name: 'Compliant 1:1 Consent Roofing Leads', id: '315' },
      { name: 'Specialty Campaigns Roofing Leads', id: '306' },
      { name: 'Roofing - Bundled Leads', id: '357' },
    ],
  },
  {
    '2': [
      { name: 'Compliant Non 1:1 Consent Windows Leads', id: '73' },
      // { name: 'Compliant 1:1 Consent Windows Leads', id: '318' },
      { name: 'Specialty Campaigns Windows Leads', id: '304' },
      { name: 'Windows - Bundled Leads', id: '358' },
    ],
  },
  {
    '3': [
      { name: 'Compliant Non 1:1 Consent Siding Leads', id: '69' },
      // { name: 'Compliant 1:1 Consent Siding Leads', id: '316' },
      { name: 'Specialty Campaigns Siding Leads', id: '307' },
      { name: 'Siding - Bundled Leads', id: '360' },
    ],
  },
  {
    '5': [
      { name: 'Compliant Non 1:1 Consent Bathroom Leads', id: '74' },
      // { name: 'Compliant 1:1 Consent Bathroom Leads', id: '310' },
      { name: 'Specialty Campaigns Bathroom Leads', id: '303' },
      { name: 'Bathroom Remodel - Bundled Leads', id: '355' },
    ],
  },
  {
    '6': [
      { name: 'Compliant Non 1:1 Consent Walk-In Tub Leads', id: '75' },
      // { name: 'Compliant 1:1 Consent Walk-In Tub Leads', id: '317' },
      { name: 'Specialty Campaigns Walk-In Tub Leads', id: '308' },
      { name: 'Walk-In Tub - Bundled Leads', id: '359' },
    ],
  },
  {
    '14': [
      { name: 'Compliant Non 1:1 Consent Door Leads', id: '70' },
      // { name: 'Compliant 1:1 Consent Door Leads', id: '312' },
    ],
  },
  {
    '22': [
      { name: 'Compliant Non 1:1 Consent Gutters Leads', id: '72' },
      // { name: 'Compliant 1:1 Consent Gutters Leads', id: '313' },
      { name: 'Specialty Campaigns Gutters Leads', id: '305' },
      { name: 'Gutters - Bundled Leads', id: '356' },
    ],
  },
  {
    '24': [
      { name: 'Compliant Non 1:1 Consent HVAC Leads', id: '401' },
    ],
  },
  {
    '11': [
      { name: 'Compliant Non 1:1 Consent Floor Leads', id: '398' },
    ],
  },
  {
    '12': [
      { name: 'Compliant Non 1:1 Consent Kitchen Leads', id: '71' },
      // { name: 'Compliant 1:1 Consent Kitchen Leads', id: '314' },
    ],
  },
];


export const verticalIDToCallOffers: { [key: string]: VerticalOffer[] }[] = [
  {
    '5': [
      { id: '255', name: 'Inbounds Bathroom 90 Sec.' },
      { id: '252', name: 'Inbounds Bathroom 120 Sec.' },
      { id: '220', name: 'Transfers Bathroom 90 Sec.' },
      { id: '211', name: 'Transfers Bathroom 120 Sec.' },
      { id: '373', name: 'Bathroom Remodel - Bundled Transfer Calls 90 Sec.' },
      { id: '374', name: 'Bathroom Remodel - Bundled Transfer Calls 120 Sec.' },
      { id: '361', name: 'Bathroom Remodel - Bundled Inbound Calls 90 Sec.' },
      { id: '362', name: 'Bathroom Remodel - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Bathroom Calls', id: '295' },
    ]
  },
  {
    '19': [
      { id: '259', name: 'Inbounds Cabinet Replacing 90 Sec.' },
      { id: '256', name: 'Inbounds Cabinet Replacing 120 Sec.' },
      { id: '221', name: 'Transfers Cabinet Replacing 90 Sec.' },
      { id: '212', name: 'Transfers Cabinet Replacing 120 Sec.' }
    ]
  },
  {
    '14': [
      { id: '263', name: 'Inbounds Doors 90 Sec.' },
      { id: '260', name: 'Inbounds Doors 120 Sec.' },
      { id: '222', name: 'Transfers Doors 90 Sec.' },
      { id: '213', name: 'Transfers Doors 120 Sec.' }
    ]
  },
  {
    '22': [
      { id: '267', name: 'Inbounds Gutters 90 Sec.' },
      { id: '264', name: 'Inbounds Gutters 120 Sec.' },
      { id: '223', name: 'Transfers Gutters 90 Sec.' },
      { id: '214', name: 'Transfers Gutters 120 Sec.' },
      { id: '375', name: 'Gutters - Bundled Transfer Calls 90 Sec.' },
      { id: '376', name: 'Gutters - Bundled Transfer Calls 120 Sec.' },
      { id: '363', name: 'Gutters - Bundled Inbound Calls 90 Sec.' },
      { id: '364', name: 'Gutters - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Gutters Calls', id: '300' },
    ]
  },
  {
    '24': [
      { id: '400', name: 'Inbounds HVAC 90 Sec.' },
      { id: '403', name: 'Transfers HVAC 90 Sec.' },
    ]
  },
  {
    '11': [
      { id: '399', name: 'Inbounds Floor 90 Sec.' },
      { id: '404', name: 'Transfers HVAC 90 Sec.' },
    ]
  },
  {
    '12': [
      { id: '271', name: 'Inbounds Kitchen 90 Sec.' },
      { id: '268', name: 'Inbounds Kitchen 120 Sec.' },
      { id: '224', name: 'Transfers Kitchen 90 Sec.' },
      { id: '215', name: 'Transfers Kitchen 120 Sec.' },
      { id: '385', name: 'Kitchen - Bundled Transfer Calls 90 Sec.' },
      { id: '386', name: 'Kitchen - Bundled Transfer Calls 120 Sec.' },
      { id: '387', name: 'Kitchen - Bundled Inbound Calls 90 Sec.' },
      { id: '388', name: 'Kitchen - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Kitchen Calls', id: '302' },
    ]
  },
  {
    '1': [
      { id: '275', name: 'Inbounds Roofing 90 Sec.' },
      { id: '272', name: 'Inbounds Roofing 120 Sec.' },
      { id: '225', name: 'Transfers Roofing 90 Sec.' },
      { id: '216', name: 'Transfers Roofing 120 Sec.' },
      { id: '377', name: 'Roofing - Bundled Transfer Calls 90 Sec.' },
      { id: '378', name: 'Roofing - Bundled Transfer Calls 120 Sec.' },
      { id: '365', name: 'Roofing - Bundled Inbound Calls 90 Sec.' },
      { id: '366', name: 'Roofing - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Roofing Calls', id: '299' },
    ]
  },
  {
    '2': [
      { id: '288', name: 'Inbounds Windows 90 Sec.' },
      { id: '285', name: 'Inbounds Windows 120 Sec.' },
      { id: '226', name: 'Transfers Windows 90 Sec.' },
      { id: '217', name: 'Transfers Windows 120 Sec.' },
      { id: '379', name: 'Windows - Bundled Transfer Calls 90 Sec.' },
      { id: '380', name: 'Windows - Bundled Transfer Calls 120 Sec.' },
      { id: '367', name: 'Windows - Bundled Inbound Calls 90 Sec.' },
      { id: '368', name: 'Windows - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Windows Calls', id: '296' },
    ]
  },
  {
    '6': [
      { id: '284', name: 'Inbounds Walk-In Tub 90 Sec.' },
      { id: '281', name: 'Inbounds Walk-In Tub 120 Sec.' },
      { id: '227', name: 'Transfers Walk-In Tub 90 Sec.' },
      { id: '218', name: 'Transfers Walk-In Tub 120 Sec.' },
      { id: '381', name: 'Walk-In Tub - Bundled Transfer Calls 90 Sec.' },
      { id: '382', name: 'Walk-In Tub - Bundled Transfer Calls 120 Sec.' },
      { id: '369', name: 'Walk-In Tub - Bundled Inbound Calls 90 Sec.' },
      { id: '370', name: 'Walk-In Tub - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Walk-In Tub Calls', id: '297' },
    ]
  },
  {
    '3': [
      { id: '279', name: 'Inbounds Siding 90 Sec.' },
      { id: '276', name: 'Inbounds Siding 120 Sec.' },
      { id: '228', name: 'Transfers Siding 90 Sec.' },
      { id: '219', name: 'Transfers Siding 120 Sec.' },
      { id: '383', name: 'Siding - Bundled Transfer Calls 90 Sec.' },
      { id: '384', name: 'Siding - Bundled Transfer Calls 120 Sec.' },
      { id: '371', name: 'Siding - Bundled Inbound Calls 90 Sec.' },
      { id: '372', name: 'Siding - Bundled Inbound Calls 120 Sec.' },
      { name: 'Specialty Campaigns Siding Calls', id: '298' },
    ]
  }
];


export type VerticalVisualData = {
  icon: JSX.Element;
  color: string;
  image: string;
};
